export const findLabelByName = (object, propertyName, name) => {
  const matchingType = object[propertyName].find(item => item.name === name);
  return matchingType ? matchingType.label : '-';
};


// Function to get the cart data from local storage
export const getCartData = () => {
  const cartData = localStorage.getItem('cart');
  return cartData ? JSON.parse(cartData) : [];
};

// Function to save the cart data to local storage
export const saveCartData = (cart) => {
  localStorage.setItem('cart', JSON.stringify(cart));
};

// Function to add an item to the cart
export const addItemToCart = (item) => {
  const cart = getCartData();
  cart.push(item);
  saveCartData(cart);
};

// Function to delete a specific item from the cart based on its ID
export const deleteItemFromCart = (itemId) => {
  const cart = getCartData();
  const updatedCart = cart.filter(item => item.id !== itemId);
  saveCartData(updatedCart);
};

// Function to clear the entire cart
export const clearCart = () => {
  localStorage.removeItem('cart');
};

function getLocalStorageItem(key) {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error retrieving item "${key}" from local storage:`, error);
    return null;
  }
}

const setLocalStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error setting local storage item:', error);
  }
};

export const initializeCart = () => {
  const existingCart = getLocalStorageItem('cart');
  if (!existingCart) {
    const initialCart = [];
    setLocalStorageItem('cart', initialCart);
    return initialCart;
  }
  return existingCart;
};


export const calculateTotalPrice = (cart) => {
  let totalPrice = 0;

  cart.forEach((item) => {
    totalPrice += Number(item.price);

    if (item.additionalItem && item.additionalItem.length > 0) {
      item.additionalItem.forEach((additional) => {
        if (additional.price) {
          totalPrice += Number(additional.price);
        }
      });
    }
  });

  return totalPrice;
};
